import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FEATURE_NAME } from '../domain/utils-chest.config';
import { UtilsState } from './utils.state';

export const MainSelector = createFeatureSelector<UtilsState>(FEATURE_NAME);

export const propertyRegister = createSelector(MainSelector, (state) => state.propertyRegister);
